import React, { Component } from "react";
import moment from "moment";
//import { Link } from 'react-router-dom';
import Table from "./common/table";
import { Link } from "react-router-dom";

const $ = require("jquery");
$.DataTable = require("datatables.net");

class ClosedTradesTable extends Component {
  columns = [
    {
      path: "user_email",
      label: "Trade By",
      content: (ctrade) => ctrade.user_email,
    },
    {
      path: "trade_reference",
      label: "Reference:",
    },
    {
      path: "tradeTypeId",
      label: "Trade Type:",
      content: (ctrade) => ctrade.trade_type.name,
    },
    {
      path: "tradeResponseId",
      label: "Trade Response:",
      content: (ctrade) => ctrade.trade_response.name,
    },
    { path: "processed_by", label: "Closed By:" },

    {
      path: "trade_closing_date",
      label: "Closing Date",
      content: (ctrade) =>
        moment(ctrade.trade_closing_date).startOf("day").format("LL"),
    },
    {
      key: (ctrade) => `${ctrade._id}-s`,
      label: "Info",
      content: (ctrade) => (
        <Link
          to={`/closed_trades/show/${ctrade._id}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      ),
    },
  ];

  componentDidMount() {
    $(document).ready(function () {
      $("#dataTable").DataTable();
    });
  }

  render() {
    const { closedTrades, message } = this.props;
    console.log(closedTrades, message);
    return (
      <Table columns={this.columns} data={closedTrades} message={message} />
    );
  }
}

export default ClosedTradesTable;
